import { TeamSpritesDisplay } from "@/components/pokemon/team-sprites-display";
import { StandardFrame } from "@/components/ui/frames/standard-frame";
import { useLeaderboard } from "@/hooks/queries/use-leaderboard";
import { useSPAContext } from "@/providers/spa-provider";
import { useUser } from "@/providers/user-provider";
import { RouteNames } from "@/types/route-names";

export const PlayMenuStatusWindow = () => {
  const { playerElo, playerWins, playerLosses, mainDeckPokemons } = useUser();
  const { data: leaderboard } = useLeaderboard();
  const { setCurrentRoute } = useSPAContext();
  const rank = leaderboard?.current_user_entry?.rank;

  const total = (playerWins ?? 0) + (playerLosses ?? 0);
  const winRate =
    total > 0 ? Math.round(((playerWins ?? 0) / total) * 100) : null;

  const hasSquad = mainDeckPokemons.length > 0;

  return (
    <StandardFrame variant="blue" rounded>
      <div className="flex flex-col">
        <div className="flex items-center justify-between px-3 pt-2 pb-1">
          <span className="text-pk-blue-5 text-[9px] font-black uppercase tracking-[0.2em]">
            Status
          </span>
          {hasSquad && (
            <button
              type="button"
              onClick={() => setCurrentRoute(RouteNames.ITEM_DECK_LIST)}
              className="text-pk-gray-4 text-[9px] font-black uppercase tracking-widest active:text-white"
            >
              Squad ▸
            </button>
          )}
        </div>

        <div className="flex items-stretch divide-x-2 divide-pk-blue-5/40 border-t-2 border-pk-blue-5/40">
          <StatCell
            label="Elo"
            value={playerElo ?? "—"}
            accent="text-pk-yellow-3"
          />
          <StatCell
            label="W / L"
            value={
              playerWins !== null && playerLosses !== null
                ? `${playerWins}/${playerLosses}`
                : "—"
            }
            sub={winRate !== null ? `${winRate}%` : undefined}
            accent="text-pk-green-5"
          />
          <StatCell
            label="Rank"
            value={rank != null ? `#${rank}` : "—"}
            accent="text-pk-cream-2"
          />
        </div>

        {hasSquad && (
          <button
            type="button"
            onClick={() => setCurrentRoute(RouteNames.ITEM_DECK_LIST)}
            className="flex items-center justify-center border-t-2 border-pk-blue-5/40 px-2 py-1.5 active:bg-pk-blue-3/40"
          >
            <TeamSpritesDisplay team={mainDeckPokemons.slice(0, 4)} />
          </button>
        )}
      </div>
    </StandardFrame>
  );
};

const StatCell = ({
  label,
  value,
  sub,
  accent,
}: {
  label: string;
  value: string | number;
  sub?: string;
  accent: string;
}) => (
  <div className="flex-1 flex flex-col items-center justify-center py-2.5 px-1 gap-0.5">
    <span className="text-pk-blue-5/80 text-[8px] font-black uppercase tracking-widest leading-none">
      {label}
    </span>
    <span
      className={`${accent} font-black text-base leading-tight drop-shadow-[1px_1px_0_rgba(0,0,0,0.6)]`}
    >
      {value}
    </span>
    {sub && (
      <span className="text-pk-gray-4 text-[9px] font-bold leading-none">
        {sub}
      </span>
    )}
  </div>
);
